(function () {
    var voucherStatuses = [
        "Unknown",
        "Voucher",
        "Voucher",
        "Reversed",
        "Reversing",
    ];

    function voucherStatusFilter() {
        return function (input) {

            // If the input is undefined or null, we return undefined|null so that bind once continues to bind until the value is not null.
            if (!input) {
                return input;
            }

            return voucherStatuses[input];
        };
    }

    angular
        .module('dashboard')
        .filter('voucherStatus', [ voucherStatusFilter ]);
})();
